import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const useSlideMarker = (markerWidth: number): [string, Dispatch<SetStateAction<number>>] => {
    const [markerLeftPercent, setMarkerLeftPercent] = useState<number>(0);
    const [markerAdjustmentPixels, setMarkerAdjustmentPixels] = useState<number>(markerWidth / 2);
    
    useEffect(() => {
        setMarkerAdjustmentPixels(Math.cos(markerLeftPercent * Math.PI) * (markerWidth / 2));
    }, [markerLeftPercent]);
    
    return [`calc(${ markerLeftPercent * 100 }% + ${ markerAdjustmentPixels }px)`, setMarkerLeftPercent];
};